/** 允许展示的图片后缀（按 URL pathname 判断，不区分大小写） */
const IMAGE_EXT_RE = /\.(jpe?g|png|webp|gif)$/i

/**
 * 判断是否为可展示的图片链接：
 * - 空、null、纯空白 → false
 * - 只看 pathname 的后缀，查询参数/片段里出现 .jpg 不算（如 `/a.html?x=1.jpg` → false）
 * - 合法图片带查询参数/片段仍通过（如 `/a.jpg?v=2#t` → true）
 * - 相对路径同样按 pathname 判断
 */
export function isValidImageUrl(url: string | null | undefined): boolean {
  const trimmed = (url ?? '').trim()
  if (!trimmed) return false
  try {
    const { pathname } = new URL(trimmed, 'https://placeholder.local')
    return IMAGE_EXT_RE.test(pathname)
  } catch {
    return false
  }
}
